<template>
    <div class="bg-grey">
        <b-container>
            <BlogPageControls :blogId="blogId"/>
        </b-container>
        <AppFooter class="mt-5"/>
        <PresentationCenter id="presentation"/>
    </div>
</template>

<script>
import BlogPageControls from '@/components/BlogPageControls';
import blogItems from '@/json/blog';
import AppFooter from '@/components/AppFooter'
import PresentationCenter from '@/components/PresentationCenter'

export default {
    props: ['blogId'],
    data() {
        return {
            blogContent: {}
        }
    },
    components: {
        BlogPageControls,
        AppFooter,
        PresentationCenter
    },
    mounted() {
        var currentBlog = blogItems.data.filter(item => {
            return item.id == this.blogId
        });
        this.blogContent = currentBlog["0"];
    }
}
</script>